import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'reactstrap'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const Container = styled.div`
  text-align: center;
  .timeline {
    font-size: 30px;
    font-weight: ${fontWeight.bold};
    color: #093883;
    margin-top: 0;
    margin-bottom: 56px;
    display: block;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    .timeline {
      margin-bottom: 0;
      font-size: 1.25rem;
    }
  }
`

const ComponentStyle = styled(Row)`
  align-items: center;
  /* justify-content: center; */
`

const ContentLeft = styled(Col)`
  /* flex: 1; */
  text-align: center;
  font-size: 20px;
  padding-left: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
  }
`

const Center = styled(Col)`
  padding-top: 16px;
  padding-bottom: 16px;
  .image {
    display: inline-block;
    height: 250px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    img {
      height: 180px;
    }
  }
`

const ContentRight = styled(Col)`
  text-align: center;
  font-size: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 16px;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
  }
`

const Component = ({ contentLeft, timeline, image, contentRight }) => (
  <Container>
    <span className='timeline'>{timeline}</span>
    <ComponentStyle>
      <ContentLeft xs={12} lg={4}>
        {contentLeft}
      </ContentLeft>
      <Center xs={12} lg={4}>
        <img src={image.publicURL} className='image' alt={timeline} />
      </Center>
      <ContentRight xs={12} lg={4}>
        {contentRight}
      </ContentRight>
    </ComponentStyle>
  </Container>
)

export default Component
